import React from 'react';

export const ModernInvoicePageConfigGuaranFeeder = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth : ['master', 'rh', 'rh_not_signer', 'director', 'funcionario'],
    routes  : [
        {
            path     : '/invoice-guaran-feeder/:id?/:status?/:message?',
            component: React.lazy(() => import('./ModernInvoicePage'))
        }
    ]
};